import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { APPLICATION_EVENT_TYPES, EVENT_TYPES } from 'src/interfaces/enums';
import ApplicationService from 'src/services/ApplicationService';
import { SELECTOR_CSAT_AVAILABLE_EVENTS } from 'src/store/reducers/csat/csat.selectors';
import { dispatchEventToWindow } from 'src/utils/browserUtils';

type EventType = EVENT_TYPES | APPLICATION_EVENT_TYPES;

export const useCsatTriggerEvent = () => {
  const availableCsatsEvents = useSelector(SELECTOR_CSAT_AVAILABLE_EVENTS);
  const triggerEventByEventType = useCallback((eventType: EventType) => {
    return EVENT_TYPES[eventType]
      ? ApplicationService.player?.triggerEvent(EVENT_TYPES[eventType])
      : dispatchEventToWindow(eventType);
  }, []);

  return {
    triggerEventByEventType,
    availableCsatsEvents,
  };
};
